import type { FC } from "react";

import WhitelistCategoryView from "../components/WhitelistCategoryView";

const InsolvencyMonitorWhitelistRoute: FC = () => {
  return (
    <WhitelistCategoryView
      category="insolvency-monitor"
      title="Insolvency monitor"
    />
  );
};

export default InsolvencyMonitorWhitelistRoute;
